module.exports = __webpack_public_path__ + "static/media/Text_Legal.0fb75576.jpg";